import { Action } from '../actions/action';
import { DrawDeckAction } from '../actions/draw-deck-action';
import { Board } from '../board';
import { GameLogicDepth } from '../game-logic-depth';
import { GameLogicScore } from '../game-logic-score';
import { Command } from './command';

export class DrawDeckMoveCommand implements Command {
  public serializeToString(): string {
    return `drawdeck`;
  }

  public execute(
    board: Board,
    gameScore: GameLogicScore,
    gameLogicDepth: GameLogicDepth,
    actionList: Action[],
  ): boolean {
    const action = new DrawDeckAction(board, gameLogicDepth);
    action.execute();
    actionList.push(action);

    gameScore.addMove();

    return true;
  }

  public static isCommand(command: Command): command is DrawDeckMoveCommand {
    return command instanceof DrawDeckMoveCommand;
  }
}
